// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Orders_UpdateItemDeliveryDateInput.php
// Do not edit by hand — edit the PHP InputContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * InputContract for POST /so/orders/update_item_delivery_date/{item_id}
 *
 * JSON body:
 * {
 *   "expected_delivery_at": "2026-06-01T18:00:00Z",  // ISO 8601 UTC, required
 *   "reason": "Cliente solicitou alteracao"            // free-text, required, non-blank
 * }
 */
import { registerContract } from './validate'

export interface Orders_UpdateItemDeliveryDateInput {
expected_delivery_at: string
reason: string
}

registerContract('Orders_UpdateItemDeliveryDateInput', {
  expected_delivery_at: { type: 'string',  required: true },
  reason:               { type: 'string',  required: true },
})
